module.exports = __webpack_public_path__ + "assets/img/scenic_09.2fb0708d.svg";